import { NumberInput, NumberInputProps, useMantineTheme } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";
import { useHover } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

interface IProps extends NumberInputProps {
  name: string;
}

export default function NumberInputControlled({ name, ...props }: IProps) {
  const theme = useMantineTheme();
  const { control } = useFormContext();
  const { hovered } = useHover();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <NumberInput
          error={!!error?.message ? t(error.message) : ""}
          stepHoldDelay={500}
          stepHoldInterval={(t) => Math.max(1000 / t ** 2, 25)}
          styles={{
            input: {
              cursor: "pointer",
              borderColor: hovered
                ? theme.colors.primary[1]
                : theme.colors.basic[2],
            },
          }}
          {...field}
          {...props}
        />
      )}
    />
  );
}
